export default "__VITE_ASSET__BDJ3bqJe__"